(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- Pattes qui jaillissent ---------- */
  var PAW = '<svg viewBox="0 0 32 32"><ellipse cx="6.5" cy="14" rx="3" ry="4"/><ellipse cx="12.5" cy="8" rx="3" ry="4.2"/><ellipse cx="19.5" cy="8" rx="3" ry="4.2"/><ellipse cx="25.5" cy="14" rx="3" ry="4"/><path d="M16 15c-5 0-9 4-9 8 0 3 2.5 4 5 3.5 1.5-.3 2.5-.8 4-.8s2.5.5 4 .8c2.5.5 5-.5 5-3.5 0-4-4-8-9-8z"/></svg>';
  function burst(host, x, y) {
    if (reduce || !host || !host.animate) return;
    var colors = ['#F0A93B', '#F7D774', '#FFFCF6', '#E07A45', '#BFE3EA'];
    for (var i = 0; i < 14; i++) {
      var p = document.createElement('span');
      p.className = 'paw-bit';
      p.innerHTML = PAW;
      p.style.left = x + 'px';
      p.style.top = y + 'px';
      p.style.color = colors[i % colors.length];
      host.appendChild(p);
      var a = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
      var d = 70 + Math.random() * 90;
      var anim = p.animate([
        { transform: 'translate(-50%,-50%) scale(.4) rotate(0deg)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + Math.cos(a) * d + 'px), calc(-50% + ' + (Math.sin(a) * d - 40) + 'px)) scale(1) rotate(' + (Math.random() * 120 - 60) + 'deg)', opacity: 0 }
      ], { duration: 900 + Math.random() * 400, easing: 'cubic-bezier(.2,.8,.2,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
  }

  /* ---------- Scène : le chien, l'os, le chat ---------- */
  document.querySelectorAll('[data-scene]').forEach(function (scene) {
    var hint = scene.querySelector('[data-scene-hint]');
    var reward = scene.querySelector('[data-scene-reward]');
    var host = scene.querySelector('[data-paw-burst]');
    var bone = scene.querySelector('.bone');
    var cat = scene.querySelector('.cat');
    var dog = scene.querySelector('.dog');
    var started = false;
    var catTimer = null;

    function setDog(s) { scene.setAttribute('data-dog', s); }
    function setCat(s) { scene.setAttribute('data-cat', s); }

    function catNap() {
      clearTimeout(catTimer);
      catTimer = setTimeout(function () {
        setCat('yawn');
        catTimer = setTimeout(function () { setCat('sleep'); }, 1300);
      }, 4500);
    }

    function run() {
      if (started) return;
      started = true;
      if (reduce) { setDog('happy'); setCat('sleep'); return; }
      setDog('walk');
      catNap();
      wait(4300).then(function () { setDog('sniff'); return wait(2000); })
        .then(function () { setDog('dig'); return wait(2600); })
        .then(function () {
          setDog('happy');
          if (hint) hint.textContent = 'Il a trouvé un os ! Cliquez dessus pour découvrir la surprise.';
        });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var vis = entries[0].isIntersecting;
        scene.classList.toggle('is-paused', !vis);
        if (vis) run();
      }, { threshold: 0.2 }).observe(scene);
    } else { run(); }

    function openReward(e) {
      if (scene.getAttribute('data-dog') !== 'happy') return;
      var r = scene.getBoundingClientRect();
      var pt = e && e.clientX ? { x: e.clientX - r.left, y: e.clientY - r.top } : { x: r.width / 2, y: r.height * 0.7 };
      burst(host, pt.x, pt.y);
      scene.classList.remove('dog-jump'); void scene.offsetWidth; scene.classList.add('dog-jump');
      if (reward) {
        reward.hidden = false;
        requestAnimationFrame(function () { reward.classList.add('is-open'); });
        var btn = reward.querySelector('button.btn');
        if (btn) setTimeout(function () { btn.focus(); }, 300);
      }
    }
    if (bone) {
      bone.addEventListener('click', openReward);
      bone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openReward(); } });
    }
    if (dog) dog.addEventListener('click', function () {
      scene.classList.remove('dog-jump'); void scene.offsetWidth; scene.classList.add('dog-jump');
    });
    if (reward) reward.addEventListener('click', function (e) {
      if (e.target.closest('[data-reward-close]')) {
        reward.classList.remove('is-open');
        setTimeout(function () { reward.hidden = true; }, 350);
      }
    });

    function wake(e) {
      setCat('awake');
      var r = scene.getBoundingClientRect();
      if (e && e.clientX) burst(host, e.clientX - r.left, e.clientY - r.top);
      catNap();
    }
    if (cat) {
      cat.addEventListener('click', wake);
      cat.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); wake(); } });
    }
  });

  /* ---------- Compteurs qui défilent (points fidélité) ---------- */
  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, to = parseInt(el.getAttribute('data-count-to'), 10) || 0;
        cio.unobserve(el);
        if (reduce) { el.textContent = to; return; }
        var t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1600);
          el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 900);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---------- Le petit chien qui suit la lecture de la page ---------- */
  var trail = document.querySelector('[data-trail]');
  if (trail) {
    var tDog = trail.querySelector('.trail__dog');
    var tFill = trail.querySelector('.trail__fill');
    var tTrack = trail.querySelector('.trail__track');
    var idle = null, ticking = false;
    function place() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var k = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      var w = tTrack.clientWidth - tDog.clientWidth;
      tDog.style.transform = 'translateX(' + (k * w) + 'px)';
      tFill.style.width = (k * 100) + '%';
      trail.classList.toggle('is-home', k > 0.97);
      trail.classList.toggle('is-shown', window.scrollY > 200);
    }
    window.addEventListener('scroll', function () {
      trail.classList.add('is-running');
      clearTimeout(idle);
      idle = setTimeout(function () { trail.classList.remove('is-running'); }, 180);
      if (!ticking) { ticking = true; requestAnimationFrame(place); }
    }, { passive: true });
    window.addEventListener('resize', place);
    place();
  }

  /* ---------- Points gagnés dans le panier ---------- */
  var ptsEl = document.querySelector('[data-pts]');
  if (ptsEl) {
    var ppe = parseFloat(ptsEl.getAttribute('data-ppe')) || 0;
    var label = ptsEl.getAttribute('data-label') || 'points';
    var update = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var n = Math.floor(c.total_price / 100 * ppe);
        ptsEl.hidden = n <= 0;
        ptsEl.querySelector('[data-pts-n]').textContent = n + ' ' + label;
      }).catch(function () {});
    };
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () { if (drawer.getAttribute('aria-hidden') === 'false') update(); })
        .observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'], subtree: false });
      var items = drawer.querySelector('[data-cart-total]');
      if (items) new MutationObserver(update).observe(items, { childList: true, characterData: true, subtree: true });
    }
    update();
  }
})();
